var React = require('react');
import { Box, Container, Grid } from '@mui/material';
import MUIDataTable from 'mui-datatables';
import DeleteIcon from "@material-ui/icons/Delete";
import SearchIcon from "@material-ui/icons/Search";
import SaveIcon from "@material-ui/icons/Save";
import IconButton from '@mui/material/IconButton';
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import Typography from '@mui/material/Typography';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from "@mui/material/Select";
import moment from "moment";
import CheckIcon from '@mui/icons-material/Check';
import DoNotDisturbIcon from '@mui/icons-material/DoNotDisturb';
import { MuiThemeProvider } from '@material-ui/core/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import EventDialog from '../CreateDialogue/EventDialog';
import EditEventsDialog from '../EditDialogue/EditEventsDialog';
import { muiThemeDesign } from '../../mui-theme-design';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import {logger, customBodyForExcelReport,handleExport} from '../../utils';
const ExcelJS = require('exceljs');

export default function EventsTable() {
    const [refresh, setRefresh] = React.useState(true);
    const [rates, setRates] = React.useState([]);
    const [LockedAlert, setAlert] = React.useState(false);
    const [AlertText, setAlertText] = React.useState('');
    const [expand, setExpand] = React.useState(false);
    const [eventsData, setEventsData] = React.useState([]);
     const [isLoading, setIsLoading] = React.useState(true);
    
		
    const handleDialogCallback = (childData) => {
        fetch("api/create_events", {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                "events": {
                    "EventName": childData.EventName,
                    "EventDescription": childData.EventDescription,
                    "EndDate": childData.EndDate,
                    "IsActive": childData.IsActive ? 1 : 0,
                    "Recurring": childData.Recurring,
			        "RecurringStart": childData.RecurringStart,
			        "RecurringPeriod": childData.RecurringPeriod,
			        "Urgent": childData.Urgent ? 1 : 0
                }
            })
        }).then(res => res.json()
        ).then(json => {
        })

        logger(childData);
        setRefresh(true);
    };

    const handleEditCallback = (childData) => {
        fetch("api/update_events", {
            method: 'PATCH',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                "events": {
					"ID": childData.ID,
                    "EventName": childData.EventName,
                    "EventDescription": childData.EventDescription,
                    "EndDate": childData.EndDate,
                    "IsActive": childData.IsActive ? 1 : 0,
                    "Recurring": childData.Recurring,
			        "RecurringStart": childData.RecurringStart,
			        "RecurringPeriod": childData.RecurringPeriod,
			        "Urgent": childData.Urgent ? 1 : 0
                }
            })
        })
        logger(childData);
        setRefresh(true)
    };
			
    const handleAlertClose = () => {
        setAlert(false);
    };
    
    React.useEffect(() => {
        if (refresh) {
            fetch('/api/get_all_events')
	            .then(res => res.json())
	            .then(json => setEventsData(json))
	            .catch(err => {
                console.error(err);
            });
            setIsLoading(false)
            setRefresh(false)
        }
    })
    
    
     const columns = [
        {
            name: "Action",
            options: {
                filter: false,
                sort: false,
                empty: true,
                print: false,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    return (
                        <div>
                            <EditEventsDialog handleEditCallback={handleEditCallback} data={eventsData[dataIndex]} />
                        </div>
                    );
                }

            }
        },
        {
            name: "EventName",
            label: "Event Name",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: "EventText",
            label: "Event Description",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: "EndDate",
            label: "EndDate",
            options: {
                filter: false,
                sort: true,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    return (
                        moment.utc(eventsData[dataIndex].EndDate).format("MM/DD/YYYY")
                    );
                }
            }
        },
        {
            name: "IsActive",
            options: {
                filter: true,
                sort: true,
                empty: true,
                //filterList: [1],
                customFilterListOptions:
                {
                    render: v => {
                        if (v === 0) {
                            return "Show InActive";
                        }
                        if (v === 1) {
                            return "Show Active";
                        }
                        return val;
                    },
                },

                filterOptions: {
                    renderValue: val => {
                        if (val === 0) {
                            return "InActive";
                        }
                        if (val === 1) {
                            return "Active";
                        }
                        return val;
                    }

                },
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    return (
                        <div>
                            {(eventsData[dataIndex].IsActive) ? <CheckIcon /> : <DoNotDisturbIcon />}
                        </div>
                    );

                }
            }
        }
	];
	
  const options = {
        filter: true,
        filterType: 'dropdown',
        responsive: 'vertical',
      selectableRows: 'none',
      rowsPerPage: 100,
      rowsPerPageOptions: [10, 20, 50, 100],
      textLabels: {
			toolbar: {
			  search: "Search",
			  downloadCsv: "Download Excel", 
			  print: "Print",
			  viewColumns: "View Columns",
			  filterTable: "Filter Table",
				},
		},
		  onDownload: (buildHead, buildBody, columns, data) => {
			// Custom buildHead and buildBody functions
			const customBuildHead = () => {
				var newColumns = columns.map(column => column.label);
				return newColumns;
			}
		
			const customBuildBody = () => {
				const headers = customBuildHead();
				return customBodyForExcelReport({data:data, headers:headers, columnIndexToRemove:0});
			};
			
			const headers = customBuildHead();
			const rows = customBuildBody();
			handleExport({rows:rows, headers:headers, filename:'Events.xlsx', columnIndexToRemove:0});
			return false;
		},
      customToolbar: () => {
		  return !isLoading ? <EventDialog handleDialogCallback={handleDialogCallback} />: null;
      },
    };

    return (       
        <Box>
            <MuiThemeProvider theme={muiThemeDesign}>
                <MUIDataTable className="EventsTable"
                    title={
                        <Typography variant="h6" style={{ color: "white" }}>
                            Beyondsoft Events
                        </Typography>
                    }
                    data={eventsData}
                    columns={columns}
                    options={options}
                    
                />
            </MuiThemeProvider>
            <Dialog
                open={LockedAlert}
                onClose={handleAlertClose}
                aria-labelledby="L&P Lock"
                aria-describedby="Time Period locked for this work"
            >
                <DialogTitle id="Time Entry">
                    {"Alert"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {AlertText}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => { setAlert(false) }} autoFocus>Close</Button>
                </DialogActions>
            </Dialog>
        </Box>
        
    );
}  
